import { getAllCitiesAndCountries } from '@/country'
import type { Language } from '@/tools/i18n'

export const getCityCodeFromCityName = async (
  cityName: string,
  language: Language
): Promise<string | null> => {
  const { cities } = await getAllCitiesAndCountries(language)
  const normalizedUrlCityName = cityName?.toLowerCase()
  const city = cities.find((city) => {
    const normalizedDataCityName = city.name?.toLowerCase()
    return normalizedDataCityName === normalizedUrlCityName
  })

  return city?.code.toUpperCase() || null
}

export const getCityNameFromCityCode = async (
  cityCode: string,
  language: Language
): Promise<string | null> => {
  const { cities } = await getAllCitiesAndCountries(language)
  const normalizedCityCode = cityCode?.toLowerCase()
  const city = cities.find((city) => {
    const normalizedDataCityCode = city.code?.toLowerCase()
    return normalizedDataCityCode === normalizedCityCode
  })

  return city?.name || null
}
